import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import BreadcrumbHeading from '../../components/global/BreadcrumbHeading';
import { Table, message, Modal, Input, Button, DatePicker } from 'antd';
import InputField from '../../components/global/InputField';
import swal from 'sweetalert';
import { Combobox } from 'react-widgets';
import CelaneseAPI from '../../services';
import config, { utils } from '../../config';
import { getCompaniesData } from '../../actions/index';
import './ManageSignIns.css';
import Translation from '../../Translation';
import moment from 'moment';
const stringSort = (a, b) => {
    if (a < b) { return -1; }
    if (a > b) { return 1; }
    return 0;
}
const dateSort = (a, b) => {
    if (new Date(a).getTime() < new Date(b).getTime()) { return -1; }
    if (new Date(a).getTime() > new Date(b).getTime()) { return 1; }
    return 0;
}
/**
 * Class for ManageSignIns.
 *
 * @class ManageSignIns
 * @extends {React.Component}
 */
class ManageSignIns extends React.Component {
    constructor(props) {
        super(props);
        let today = new Date();
        let fromDate = new Date();
        fromDate.setMonth(fromDate.getMonth() - 1);
        this.state = {
            loading: false,
            isModalVisible: false,
            isLongMessageModalVisible: false,
            rows: [],
            apiData: [],
            messagesList: [],
            longMessageText: '',
            userRole: 'user',
            userCompany: '',
            username: null,
            isAdd: true,
            emailAddress: '',
            firstName: '',
            lastName: '',
            password: '',
            cpassword: '',
            userCountry: '',
            errorMessage: null,
            isCreateLoading: false,

            sortedInfo: {
                columnKey: 'createdDateTime',
                order: 'descend'
            },
            filteredInfo: {},
            isDuplicateInTowplus: false,
            countryNames: [],

            startDate: moment(fromDate),
            endDate: moment(today)
        }
        
    }

    /**
     * filterDropdown function is for showing dropdown for each column in the tow items table.
     *
     * @param {Object} opts which is object, it will take selected row keys and user confirmation.
     * @memberof TranslationTable
     */
    filterDropdown = (opts) => {
        let that = this;
        return (
            <div className="custom-filter-dropdown">
                <Input
                    ref={ele => that.searchInput = ele}
                    placeholder={utils.getTranslationText('lbl_filter_text', 'Filter text or =,<,>,=>,<=')}
                    value={opts.selectedKeys ? opts.selectedKeys[0] : '' }
                    onChange={e => opts.setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={that.handleSearch(opts.selectedKeys, opts.confirm)}
                />
                <Button type="primary" onClick={that.handleSearch(opts.selectedKeys, opts.confirm)}><Translation labelName="lbl_search" defaultText="Search" /></Button>
                <Button onClick={that.handleReset(opts.clearFilters)}><Translation labelName="lbl_reset" defaultText="Reset" /></Button>
            </div>)
    }
    /**
    * onFilterDropdownVisibleChange function is for toggling the search input visibility.
    * 
    * @param {boolean} visible takes boolean as input
    * @memberof TranslationTable
    */
    onFilterDropdownVisibleChange = (visible) => {
        let that = this;
        if (visible) {
            setTimeout(() => {
                that.searchInput.focus();
            });
        }
    }
    /**
     * tableRender function is for rendering of highlighted text.
     * 
     * @param {string} text which will take string as input
     * @memberof TranslationTable
     */
    tableRender = (text) => {
        const { searchText } = this.state;
        return searchText ? (
            <span>
                {text.split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i')).map((fragment, i) => (
                    fragment.toLowerCase() === searchText.toLowerCase()
                        ? <span key={i} className="highlight">{fragment}</span> : fragment // eslint-disable-line
                ))}
            </span>
        ) : text;
    }
    /**
     * handleSearch function is for performing search on the table with selected row keys.
     * @param {array} selectedKeys
     * @param {func} confirmhandler
     * @memberof TranslationTable
     */
     handleSearch = (selectedKeys, confirmhandler) => () => {
        confirmhandler();
        this.setState({ searchText: selectedKeys[0] });
    }

    /**
     * handleReset function is for clearing searched fields on the table.
     * @param {func} clearFilters
     * @memberof TranslationTable
     */
    handleReset = clearFilters => () => {
        clearFilters();
        this.setState({ searchText: '' });
    }

    componentWillMount() {
        this.setState({
            loading: true
        });
        getCompaniesData().then((res) => {
            this.setState({
                apiData: res && res.data ? res.data : []
            });
        }).catch(() => { });
        this.getMessagesList();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.companiesData) {
            this.setState({
                apiData: nextProps.companiesData
            });
        }
    }

    showAddUserModal = (e) => {
        this.setState({ 
            isAdd: true, 
            visibleCompany: true, 
            errorMessage: null,

            username: '',
            password: '',
            firstName: '',
            lastName: '',
            emailAddress: '',
            cpassword: '',
            userRole: 'user',
            userCompany: '',
            isDuplicateInTowplus: false
        });
    }

    showAddCompanyModal = (e, rec) => {
        e && e.preventDefault();
        this.setState({
            visibleCompany: true,
            editCompanyData: rec ? rec : '',
            username: rec.username,
            isAdd: false,
            errorMessage: null,
            emailAddress: rec.username,
            firstName: rec.azureProfile && rec.azureProfile.firstName ? rec.azureProfile.firstName : '',
            lastName: rec.azureProfile && rec.azureProfile.lastName ? rec.azureProfile.lastName: '',
            userRole: rec.azureProfile && rec.azureProfile.role ? rec.azureProfile.role: 'user',
            userCompany: rec.azureProfile && rec.azureProfile.company ? rec.azureProfile.company: ''
        });
    }

    /**
     * success function shows a success message when message is created successfully
     * @param {string} msg custom message to be shown
     * @memberof ManageUsers
     */
    success = (msg) => {
        message.success(msg, 2);
    }

    /**
     * error function shows a error message
     * @memberof ManageUsers
     */
    error = () => {
        message.error(utils.getTranslationText('msg_some_issue', 'There was some issue.'), 2);
    }

    cancelAction = () => {
    }

    /**
     * showMessagePreview function shows a preview content wrapper
     * @param {event} e event is passed
     * @param {object} rec manage message row record is passed
     * @memberof ManageUsers
     */
    showMessagePreview = (e, rec) => {
        e.preventDefault();
        const quickPreviewWrapper = document.querySelector('.quick-preview-message');
        const manageUsersTable = document.querySelector('.cmp-manage-messages__table-wrapper');
        if (rec.id && quickPreviewWrapper) {
            if (quickPreviewWrapper.offsetHeight) {
                manageUsersTable.style['height'] = (manageUsersTable.offsetHeight + quickPreviewWrapper.offsetHeight) + 'px';
            }
            quickPreviewWrapper.querySelector('.quick-preview-message-content').innerHTML = rec.subject + (rec.text && rec.text.length ? ` <a href="#" data-long-message-id= ${ rec.id } class="quick-preview-message-readmore" id="showLargeDescription">${utils.getTranslationText('link_read_more','Read More')}</a>` : '');
            quickPreviewWrapper.classList.remove('displayNone');
            document.querySelector('.main').style['padding-top'] = document.querySelector('.celanese-header').offsetHeight + 'px';
            manageUsersTable.style['height'] = (manageUsersTable.offsetHeight - quickPreviewWrapper.offsetHeight) + 'px';
            this.showLongMessageModal();
        }
    }

    /**
     * showLongMessageModal function is for showing long message modal
     * @memberof ManageUsers
     */
    showLongMessageModal = () => {
        const self = this;
        document.getElementById('showLargeDescription').addEventListener('click', (e) => {
            e.preventDefault();
            const messageId = e && e.target ? e.target.getAttribute('data-long-message-id') : null;
            if (messageId) {
                let index = 0;
                const longTextRecord = self.state.messagesList.filter((val, i) => {
                    if (val.id === messageId) {
                        index = i;
                    }
                    return true;
                });
                this.setState({
                    isLongMessageModalVisible: true,
                    longMessageText: longTextRecord.length ? longTextRecord[index].text : ''
                });
            }
        }, false);
    }

    /**
     * confirmDeleteAction function deletes the message created by the admin
     * @param {*} e here e is an event passed
     * @param {object} rec here rec refers to the record of the message being deleted
     * @memberof ManageUsers
     */
    confirmDeleteAction = (e, rec) => {
        e.preventDefault();
        if (rec.id) {
            this.setState({
                loading: true
            });
            CelaneseAPI.delete(config.API.manageUsersById.replace(':id', rec.id)).then(res => {
                if (!res.error) {
                    this.success(utils.getTranslationText('msg_user_dlt_success', 'User deleted Successfully'));
                    this.getMessagesList();
                } else {
                    this.error(utils.getTranslationText('msg_error_occured_dlt_user', 'Error occured while deleting the User'));
                }
                this.setState({
                    loading: false
                });
            }).catch(() => {
                this.error(utils.getTranslationText('msg_error_occured_dlt_user', 'Error occured while deleting the User'));
                this.setState({
                    loading: false
                });
            });
        }
    }

    /**
     * showManageMessageModal function is for showing a modal which is for creating messages
     * @memberof ManageUsers
     */
    showManageMessageModal = () => {
        this.setState({
            isModalVisible: true
        });
    }

    handleCompanyCancel = () => {
        this.setState({
            visibleCompany: false,
        });
    }

    /**
     * hideManageMessageModal function is for showing a modal which is for creating messages
     * @memberof ManageUsers
     */
    hideManageMessageModal = () => {
        this.setState({
            isModalVisible: false
        });
    }

    /**
     * hideLongMessageModal function is for hiding a modal which is for creating messages
     * @memberof ManageUsers
     */
    hideLongMessageModal = () => {
        this.setState({
            isLongMessageModalVisible: false
        });
    }

    /**
     * getMessagesList function is for getting list of all messages which are entered by the admin
     * @memberof ManageUsers
     */
    getMessagesList = () => {
        this.setState({
            loading: true
        });
        CelaneseAPI.post(config.API.signInList, {
            fromDate: this.state.startDate,
            toDate: this.state.endDate
        }).then(resp => {
            this.setState({
                messagesList: resp && resp.data ? resp.data : [],
                loading: false,
                rows: resp && resp.data ? resp.data : []
            });
        });
    }

    onCreateMessageSuccess = () => {
        this.setState({
            isModalVisible: false
        });
        this.getMessagesList();
    }

    sendEmailInvitation = (formData) => {
        if (formData['role'] && formData['role'].toUpperCase() === 'user'.toUpperCase()) {
            CelaneseAPI.post(config.API.sendInvitation, {
                "to": formData['emailAddress'],
                "firstname": formData['firstName'],
                "lastname": formData['lastName'],
                "loginUrl": window.location.origin,
                "password": formData['password']
            });
        }
    }

    updateRoleAndCompany = () => {
        if (this.state.isAdd) {
            this.setState({
                isCreateLoading: true
            });
            
            let formData = {
                "emailAddress": this.state.emailAddress,
                "firstName": this.state.firstName,
                "lastName": this.state.lastName,
                "password": this.state.password,
                "role": this.state.userRole,
                "company": this.state.userCompany,
                "country": this.state.userCountry,
                "forceChangePasswordNextSignIn": true
            };
            if (this.state.isDuplicateInTowplus) {
                formData['isDuplicateInTowplus'] = true;
            }
            CelaneseAPI.post(config.API.manageUsers, formData).then((resp) => {
                let isDuplicateInTowplus = false;
                if (resp.error) {
                    let errorToShow = 'Unable to create user, please check your fields';
                    if (resp.error.code) {
                        if (resp.error.code === 'USER_ALREADY_EXISTS') {
                            errorToShow = 'User already exists in Towplus application';
                            isDuplicateInTowplus = true;
                        }
                    }
                    if (resp.error.message) {
                        errorToShow = resp.error.message;
                        if (resp.error.message.indexOf('userPrincipalName already exists') >= 0) {
                            errorToShow = 'User already exists in Azure portal';
                        }
                    }
                    this.setState({
                        isCreateLoading: false,
                        errorMessage: errorToShow,
                        isDuplicateInTowplus
                    });
                } else {
                    this.getMessagesList();
                    message.success(utils.getTranslationText('msg_user_created_success', 'User created Successfully'), 2);
                    this.sendEmailInvitation(formData);
                    this.setState({
                        isCreateLoading: false,
                        visibleCompany: false
                    });
                }
            });
        } else {
            this.setState({
                visibleCompany: false,
                loading: true
            });
            CelaneseAPI.post(config.API.updateUserRoleAndCompany, {
                username: this.state.username,
                role: this.state.userRole,
                company: this.state.userCompany,
                "firstName": this.state.firstName,
                "lastName": this.state.lastName,
                "country": this.state.userCountry
            }).then(() => {
                this.getMessagesList();
                message.success(utils.getTranslationText('msg_user_updated_success', 'User updated Successfully'), 2);
            })
        }
    }
    updateUserRole = (e) => {
        let userCompany = this.state.userCompany;
        if (e.target.value && e.target.value.toUpperCase() === 'admin'.toUpperCase() && 
            e.target.value.toUpperCase() === 'ce-user'.toUpperCase()) {
            userCompany = '';
        }
        this.setState({
            userRole: e.target.value,
            userCompany
        });
    }
    updateUserCompany = (e) => {
        this.setState({
            userCompany: e.target.value
        });
    }
    downloadFile() {
        swal({
            title: utils.getTranslationText('msg_fetching_user_items','Fetching sign-in items'),
            text: utils.getTranslationText('msg_download_start_in_few_seconds','Download will start in few seconds...'),
            buttons: false
        });
        /**
         * API call for exporting towitems in excel format
         */
        CelaneseAPI.getBlob('/export-sign-ins?ctimestamp=' + (new Date()).getTimezoneOffset() + '&format=excel&fromDate=' + this.state.startDate + '&toDate=' + this.state.endDate).then(resp => {
            if (resp.error) {
                swal({
                    text: resp.error
                });
                return;
            }
            let element = document.getElementById('export-users-link');
            if(document.body.classList.contains('ie11')) {
                window.navigator.msSaveOrOpenBlob(resp, 'sign-in-report-' + new Date().getTime() + '.xlsx');
                swal.close();
            } else {
                element.setAttribute('href', window.URL.createObjectURL(resp));
                element.setAttribute('download', 'sign-in-report-' + new Date().getTime() + '.xlsx');
                setTimeout(() => {
                    element.click();
                    swal.close();
                }, 1000);
            }
        });
    }
    exportFile(e) {
        e.preventDefault();
        if (this.state.rows.length === 0) {
            swal({
                text: utils.getTranslationText('msg_database','Database has zero sign-in items, Do you want to continue to export with empty sign-in items?'),
                buttons: [utils.getTranslationText('lbl_no', 'No'), utils.getTranslationText('lbl_yes', 'Yes')]
            }).then((action) => {
                if (action) {
                    this.downloadFile();
                }
            });
        } else {
            this.downloadFile();
        }
    }

    handleChange = (e) => {
        if (e && e.target) {
            this.setState({
                [e.target.name]: e.target.value
            });
        }
    }

    clearFilters = (e) => {
        e.preventDefault();
        let today = new Date();
        let fromDate = new Date();
        fromDate.setMonth(fromDate.getMonth() - 1);
        this.setState({
            sortedInfo: {
                columnKey: 'createdDateTime',
                order: 'descend'
            },
            filteredInfo: {},
            startDate: moment(fromDate),
            endDate: moment(today)
        });
    }

    onTableChange = (a, b, c) => {
        this.setState({
            sortedInfo: {
                columnKey: c.columnKey,
                order: c.order || 'ascend'
            },
            filteredInfo: b
        });
    }
    handleDateChange = (e, dateType) => {
        this.setState({
            [dateType]: e
        }, () => {
            this.getMessagesList();
        });
    }

    sendInvitationToUser = (e) => {
        e.preventDefault();
        this.setState({
            loading: true
        });
        CelaneseAPI.post(config.API.sendInvitation, {
            "to": this.state.emailAddress,
            "firstname": this.state.firstName,
            "lastname": this.state.lastName,
            "loginUrl": window.location.origin
        }).then(resp => {
            this.setState({
                loading: false,
                visibleCompany: false
            });
        });
    }
    disabledDate = (current) => {
        return current && current > moment().endOf('day');
    }
    disabledFromDate = (current) => {
        // Can not select days before today and today
        return current && current > this.state.endDate;
    }
    render() {
        let { filteredInfo } = this.state;
        console.log("soft infor: ", this.state.sortedInfo);
        this.columns = [{
            title: <Translation labelName="manage_users_tbl_hdr_login_timestamp" defaultText="Login Timestamp"/>,
            key: 'createdDateTime',
            sorter: (a, b) => {
                let aTime = new Date(1989, 4, 4).getTime();
                let bTime = new Date(1989, 4, 4).getTime();
                if (a.createdDateTime && (a.createdDateTime + '').length > 0) {
                    aTime = (a.createdDateTime + '').indexOf('Z') < 0 ? a.createdDateTime - 0 : a.createdDateTime;
                }
                if (b.createdDateTime && (b.createdDateTime + '').length > 0) {
                    bTime = (b.createdDateTime + '').indexOf('Z') < 0 ? b.createdDateTime - 0 : b.createdDateTime;
                }
                return dateSort(aTime, bTime);
            },
            align: 'left',
            filteredValue: filteredInfo.createdDateTime || null,
            sortOrder: this.state.sortedInfo.columnKey === 'createdDateTime' && this.state.sortedInfo.order,
            render: (rec) => {
                let timestampDisplay = new Date(rec.createdDateTime);
                let mm = timestampDisplay.getMonth();
                mm += 1;
                mm = (mm < 10 ? '0' : '') + mm;
                let dd = timestampDisplay.getDate();
                let yyyy = timestampDisplay.getFullYear();

                var hours = timestampDisplay.getHours();
                var minutes = timestampDisplay.getMinutes();
                let ss = timestampDisplay.getSeconds();
                var ampm = hours >= 12 ? 'PM' : 'AM';
                hours %= 12;
                hours = hours ? hours : 12;
                minutes = minutes < 10 ? '0' + minutes : minutes;
                hours = (hours < 10 ? '0' : '') + hours;
                ss = (ss < 10 ? '0' : '') + ss;

                let displayTimestamp = `${mm}/${dd}/${yyyy} ${hours}:${minutes}:${ss} ${ampm}`;
                return (<span>{ displayTimestamp }</span>);
            },
            filterDropdown: this.filterDropdown,
            onFilterDropdownVisibleChange: this.onFilterDropdownVisibleChange,
            tableRender: this.tableRender,
            onFilter: (value, record) => (record['createdDateTime'] || "").toString().toLowerCase().includes(value.toLowerCase())
        },{
            title: <Translation labelName="manage_users_tbl_hdr_email" defaultText="Name"/>,
            key: 'userDisplayName',
            align: 'left',
            filterDropdown: this.filterDropdown,
            onFilterDropdownVisibleChange: this.onFilterDropdownVisibleChange,
            tableRender: this.tableRender,
            filteredValue: filteredInfo.userDisplayName || null,
            sortOrder: this.state.sortedInfo.columnKey === 'userDisplayName' && this.state.sortedInfo.order,
            sorter: (a, b) => {
                return stringSort(a.userDisplayName, b.userDisplayName);
            },
            render: (rec) => {
                let firstName = rec.userDisplayName;
                return (<span>{firstName}</span>);
            },
            onFilter: (value, rec) => {
                let valueToCheck = rec.userDisplayName;
                return (valueToCheck || "").toString().toLowerCase().includes(value.toLowerCase());
            }
        },{
            title: <Translation labelName="manage_users_tbl_hdr_email" defaultText="Email"/>,
            key: 'userPrincipalName',
            align: 'left',
            filterDropdown: this.filterDropdown,
            onFilterDropdownVisibleChange: this.onFilterDropdownVisibleChange,
            tableRender: this.tableRender,
            filteredValue: filteredInfo.userPrincipalName || null,
            sortOrder: this.state.sortedInfo.columnKey === 'userPrincipalName' && this.state.sortedInfo.order,
            sorter: (a, b) => {
                return stringSort(a.userPrincipalName, b.userPrincipalName);
            },
            render: (rec) => {
                let userPrincipalName = rec.userPrincipalName;
                return (<span>{userPrincipalName}</span>);
            },
            onFilter: (value, rec) => {
                let valueToCheck = rec.userPrincipalName;
                return (valueToCheck || "").toString().toLowerCase().includes(value.toLowerCase());
            }
        },{
            title: <Translation labelName="manage_users_tbl_hdr_email" defaultText="Role"/>,
            key: 'role',
            align: 'left',
            nocustomfilter: true,
            filteredValue: filteredInfo.role || null,
            sortOrder: this.state.sortedInfo.columnKey === 'role' && this.state.sortedInfo.order,
            filters: [
                {
                    text: <Translation labelName="role_lbl_admin" defaultText="Admin" />,
                    value: 'admin',
                },
                {
                    text: <Translation labelName="role_lbl_ce_user" defaultText="CE User" />,
                    value: 'ce-user',
                },
                {
                    text: <Translation labelName="role_lbl_user" defaultText="User" />,
                    value: 'user',
                }
            ],
            onFilter: (value, rec) => {
                let role = rec.role;
                return role.toUpperCase() === value.toUpperCase();
            },
            sorter: (a, b) => {
                return stringSort(a.role, b.role);
            },
            render: (rec) => {
                let role = rec.role;
                return (<span>{role}</span>);
            }
        },{
            title: <Translation labelName="manage_users_tbl_hdr_email" defaultText="Company"/>,
            key: 'company',
            align: 'left',
            filterDropdown: this.filterDropdown,
            onFilterDropdownVisibleChange: this.onFilterDropdownVisibleChange,
            tableRender: this.tableRender,
            filteredValue: filteredInfo.company || null,
            sortOrder: this.state.sortedInfo.columnKey === 'company' && this.state.sortedInfo.order,
            sorter: (a, b) => {
                return stringSort(a.company, b.company);
            },
            render: (rec) => {
                let company = rec.company;
                return (<span>{company}</span>);
            },
            onFilter: (value, rec) => {
                let valueToCheck = rec.company;
                return (valueToCheck || "").toString().toLowerCase().includes(value.toLowerCase());
            }
        }, {
            title: <Translation labelName="manage_users_tbl_hdr_country" defaultText="Country"/>,
            key: 'country',
            align: 'left',
            filterDropdown: this.filterDropdown,
            onFilterDropdownVisibleChange: this.onFilterDropdownVisibleChange,
            tableRender: this.tableRender,
            filteredValue: filteredInfo.country || null,
            sortOrder: this.state.sortedInfo.columnKey === 'country' && this.state.sortedInfo.order,
            sorter: (a, b) => {
                return stringSort(a.country, b.country);
            },
            render: (rec) => {
                let country = rec.country;
                return (<span>{country}</span>);
            },
            onFilter: (value, rec) => {
                let valueToCheck = rec.country;
                return (valueToCheck || "").toString().toLowerCase().includes(value.toLowerCase());
            }
        },{
            title: <Translation labelName="manage_users_tbl_hdr_function" defaultText="Function"/>,
            key: 'function',
            align: 'left',
            filterDropdown: this.filterDropdown,
            onFilterDropdownVisibleChange: this.onFilterDropdownVisibleChange,
            tableRender: this.tableRender,
            filteredValue: filteredInfo.function || null,
            sortOrder: this.state.sortedInfo.columnKey === 'function' && this.state.sortedInfo.order,
            sorter: (a, b) => {
                return stringSort(a.function, b.function);
            },
            render: (rec) => {
                let fName = rec.function;
                return (<span>{fName}</span>);
            },
            onFilter: (value, rec) => {
                let valueToCheck = rec.function;
                return (valueToCheck || "").toString().toLowerCase().includes(value.toLowerCase());
            }
        }];
        let ListItem = ({ item }) => (
            <Fragment>
                {item.name}
            </Fragment>
        );
        return (
            <Fragment>
                <div className="cmp-manage-messages__header">
                    <BreadcrumbHeading heading={<Translation labelName="title_admin_sign_in" defaultText="Sign-in List"/>} />
                    <div className="cmp-manage-messages__header-links">
                        <div className="cmp-manage-messages__header-links-wrapper">
                            {
                                this.state.rows.length ? (
                                    <h4 className="users-length-label"><Translation labelName="lbl_available_user_items" defaultText="Login items" />: <strong>{this.state.rows.length}</strong></h4>
                                ) : ''
                            }
                            <button type="button" className="btn btn-default export-file-btn" onClick={(e) => this.exportFile(e)}><Translation labelName="btn_export" defaultText="Export" /></button>
                        </div>
                        
                    </div>
                </div>
                <div className="cmp-manage-messages">
                    <div className="cmp-manage-messages__table-wrapper">
                        <div className="m1-bottom">
                            <div className="flex align-center">
                                <div className="flex-1 ">
                                    <button type="button" className="btn btn-default export-file-btn" onClick={(e) => this.clearFilters(e)}><Translation labelName="btn_clear_filters" defaultText="Clear Filters" /></button>
                                    <button type="button" className="btn btn-default m1-left" onClick={(e) => { this.clearFilters(e);this.getMessagesList(e); }}><Translation labelName="btn_clear_filters_and_reload" defaultText="Refresh Table" /></button>
                                </div>
                                <div className="flex-1 flex flex-end">
                                    <div className=''>
                                        <label><Translation labelName="lbl_country_start_date" defaultText="Start date" /> (MM/DD/YYYY)</label>
                                        <DatePicker disabledDate={this.disabledFromDate} value={this.state.startDate} format="MM/DD/YYYY" onChange={(e) => { this.handleDateChange(e, 'startDate')  }}/>
                                    </div>
                                    <div className='m2-left'>
                                        <label><Translation labelName="lbl_country_end_date" defaultText="End date" /> (MM/DD/YYYY)</label>
                                        <DatePicker disabledDate={this.disabledDate} value={this.state.endDate} format="MM/DD/YYYY" onChange={(e) => { this.handleDateChange(e, 'endDate')  }}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Table
                            dataSource={this.state.rows}
                            columns={this.columns}
                            rowKey={Math.random}
                            bordered
                            loading={this.state.loading}
                            pagination={false}
                            onChange={this.onTableChange}
                            scroll={{ y: 'calc(100vh - 300px)' }}
                            size="middle" />
                    </div>
                </div>
                {this.state.visibleCompany &&
                    <Modal
                        className="update-role-company"
                        title={ 
                            this.state.isAdd ? 
                                <Translation labelName="title_create_user" defaultText="Create User"/> : 
                                <Translation labelName="title_update_role_company" defaultText="Update role and company"/>
                            }
                        visible={this.state.visibleCompany}
                        okText={
                            this.state.isAdd ?
                            <Translation labelName="btn_save" defaultText="Submit"/> :
                            <Translation labelName="btn_save" defaultText="Save"/> 
                        }
                        onOk={() => this.updateRoleAndCompany()}
                        onCancel={this.handleCompanyCancel}
                        centered
                        width='750px'
                    >
                        <div>
                            {
                                this.state.errorMessage &&
                                (
                                    <div className="error-text">
                                        {this.state.errorMessage} { this.state.isDuplicateInTowplus && 'Try again to push user to Azure'}
                                    </div>
                                )
                            }
                            {
                                this.state.isAdd && (
                                    <Fragment>
                                        <div>
                                            <InputField
                                                type='text'
                                                label={<Fragment><Translation labelName="lbl_email_address" defaultText="Email address "/>*</Fragment>}
                                                name='emailAddress'
                                                pattern='^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$'
                                                id='emailAddress'
                                                value={this.state.emailAddress}
                                                onChange={(e) => this.handleChange(e)}
                                            />
                                        </div>
                                        
                                    </Fragment>
                                )
                            }
                            <div className="row">
                                <div className="col-sm-6">
                                    <InputField
                                        type='text'
                                        label={<Fragment><Translation labelName="lbl_firstname" defaultText="Firstname "/>*</Fragment>}
                                        name='firstName'
                                        id='firstName'
                                        value={this.state.firstName}
                                        onChange={(e) => this.handleChange(e)}
                                    />
                                </div>
                                <div className="col-sm-6">
                                    <InputField
                                        type='text'
                                        label={<Fragment><Translation labelName="lbl_lastname" defaultText="Lastname "/>*</Fragment>}
                                        name='lastName'
                                        id='lastName'
                                        value={this.state.lastName}
                                        onChange={(e) => this.handleChange(e)}
                                    />
                                </div>
                            </div>
                            <div className="row m1-bottom">
                                <div className='col-md-6'>
                                    <label><Translation labelName="lbl_country_label" defaultText="Country" /></label>
                                    <Combobox
                                        caseSensitive={false}
                                        busy={false}
                                        value={this.state.userCountry}
                                        data={this.state.countryNames}
                                        messages={{
                                            emptyList: <Translation labelName="msg_there_r_no_items_list" defaultText="There are no items in this list"/> ,
                                        }}
                                        textField='name'
                                        valueField='name'
                                        itemComponent={ListItem}
                                    />
                                </div>
                                <div className='col-md-6'>
                                    <div className="user-preference__row">
                                        <label htmlFor="userRole"><Translation labelName="hdr_user_role" defaultText="Role"/></label>
                                        <select value={this.state.userRole ? this.state.userRole : ''} name="userRole" onChange={this.updateUserRole}>
                                            {(
                                                [{
                                                    value: "admin",
                                                    key: "Admin"
                                                }, {
                                                    value: 'ce-user',
                                                    key: 'CE User'
                                                }, {
                                                    value: 'user',
                                                    key: 'User'
                                                }].map((val, i) => {
                                                    return (<option key={i} value={val.value}>{ val.key }</option>);
                                                })
                                            )}
                                        </select>
                                    </div>
                                </div>
                            </div>
                            
                            {
                                this.state.userRole === 'user' && (
                                    <div className="user-preference__row">
                                        <label htmlFor="userCompany"><Translation labelName="lbl_user_company" defaultText="Company Name"/></label>
                                        <select value={this.state.userCompany} name="userCompany" onChange={this.updateUserCompany}>
                                            <Translation labelName="lbl_none" defaultText="None" isOption />
                                            {this.state.apiData && (
                                                this.state.apiData.map((val, i) => {
                                                    return (<option key={i} value={val.company}>{val.company}</option>);
                                                })
                                            )}
                                        </select>
                                    </div>
                                )
                            }
                            {
                                !this.state.isAdd && (
                                    <div>
                                        <a className="table-links" onClick={this.sendInvitationToUser} href="#" >Send Invitation</a>
                                    </div>
                                )
                            }
                            {
                                this.state.isCreateLoading && <div className="loading-indicator">
                                    <h2 className="loading-indicator-text">
                                        {/* <Icon type="loading" theme="outlined" /> */}
                                        <img alt='loading celanese' src="./images/Celanese_loading.svg" />
                                    <span>Loading</span></h2>
                                </div>
                            }
                        </div>
                    </Modal>}
                <a href="" className="export-users-hidden" id="export-users-link" download=""></a>
            </Fragment>
        );
    }
}

const mapStateToProps = ({ loggedUserState }) => ({
    prefData: loggedUserState.prefData
});

const mapDispatchToProps = dispatch => ({
    getCompaniesData: (data) => dispatch(getCompaniesData(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(ManageSignIns);

ManageSignIns.propTypes = {
    prefData: PropTypes.object,
    companiesData: PropTypes.any,
    getCompaniesData: PropTypes.func
};


// WEBPACK FOOTER //
// ./src/containers/ManageSignIns/index.js